var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshCircleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "refresh-circle",
    d: "M76,48a28,28,0,1,0,28,28A28.033,28.033,0,0,0,76,48Zm0,42.135a12.654,12.654,0,0,1,0-25.308h.567l-1.9-1.9a1.885,1.885,0,0,1,2.665-2.665l5.385,5.385a1.885,1.885,0,0,1,0,2.665L77.333,73.7a1.885,1.885,0,0,1-2.665-2.665L77.09,68.61C76.77,68.6,76.4,68.6,76,68.6a8.885,8.885,0,1,0,8.885,8.885,1.885,1.885,0,0,1,3.769,0A12.669,12.669,0,0,1,76,90.135Z",
    transform: "translate(-48 -48)",
    fill: "#a6a6a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshCircleIcon);
export default __webpack_public_path__ + "static/media/refresh-circle-icon.357638fe964877c543e140701ced6191.svg";
export { ForwardRef as ReactComponent };